<section class="modal-content modal-content-right">
  <button cjButton aria-label="Close" class="modal-close" tabIndex="-1" (click)="onModalClose()">
    <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
  </button>

  <div class="summary-content p-6">
    <div class="flex flex-col gap-5">
      <app-summary-details
        [isLoading]="isInitLoad"
        [isRecurringInvoiceChild]="isRecurringInvoiceChild"
        [recurringParent]="recurringParent"
        [invoiceType]="invoiceType"
        [invoice]="invoice"
        [recurringInvoice]="recurringInvoice"
        [invoiceAttachments]="invoiceAttachments"
        [invoicePolicies]="invoicePolicies"
        [invoiceNotes]="invoiceNotes"
        [invoicePaid]="invoicePaid"
        [customer]="customer"
        [customerAddresses]="customerAddresses"
        [customerContacts]="customerContacts"
        [customerProfileId]="customerProfileId"
        [customFieldValues]="customFieldValues"
        [partialPayment]="partialPayment"
        [locationData]="locationData"
        [userInfo]="userInfo"
      ></app-summary-details>
      <app-summary-actions
        *ngIf="!isInitLoad"
        [invoiceType]="invoiceType"
        [invoice]="invoice"
        [recurringInvoice]="recurringInvoice"
        [invoiceSettings]="invoiceSettings"
        [customer]="customer"
        [customerProfileId]="customerProfileId"
        [isSending]="isSending"
        (printPreview)="onPrintPreview()"
        (deleteInvoice)="onDeleteInvoice()"
        (sendMail)="onSendMail()"
        (sendSchedule)="onSendSchedule()"
        (sendMultiple)="onSendMultiple($event)"
        (sendReceipt)="onSendReceipt()"
        (selectPayment)="onSelectPayment()"
        (subscriptionAction)="onSubscriptionAction($event)"
      ></app-summary-actions>
    </div>
  </div>
</section>
